import { Component, Host, h, State, EventEmitter, Event, Method } from '@stencil/core';

@Component({
  tag: 'sy-site-burger-icon',
  styleUrl: 'site-burger-icon.scss',
  shadow: true,
})
export class SiteBurgerIcon {

  private element: HTMLElement;
  @State() opened = false;

  /**
   * Emitted when burger is open
   */
  @Event({ bubbles: true }) sySiteBurgerIconDidOpen: EventEmitter;

  /**
   * Emitted when burger is closed
   */
  @Event({ bubbles: true }) sySiteBurgerIconDidClose: EventEmitter;

  /**
   * Opens the burger
   */
  @Method()
  async open(): Promise<void> {
    this.element.classList.add('open');
    this.opened = true;
    this.sySiteBurgerIconDidOpen.emit();
  }

  /**
   * Closes the burger
   */
  @Method()
  async close(): Promise<void> {
    this.element.classList.remove('open');
    this.opened = false;
    this.sySiteBurgerIconDidClose.emit();
  }

  /**
   * Toggle the burger
   */
  @Method()
  async toggle(): Promise<void> {
    if (this.opened) {
      this.close();
    } else {
      this.open();
    }
  }

  render() {
    return (
      <Host>
        <div ref={el => this.element = el} onClick={() => this.toggle()}>
          <span></span>
          <span></span>
        </div>
      </Host>
    );
  }

}
